import Vue from 'vue';

export default {
  updateTermsService(email, superOrderId) {
    return Vue.prototype.axios
      .put(`terms-service?email=${email}&superOrderId=${superOrderId}&value=1&dealerId=${Vue.prototype.$session.get('dealerId')}`)
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },

  updateNoticePrivacy(email, superOrderId, action, value) {
    return Vue.prototype.axios
      .put(`noticeOfPrivacy?email=${email}&superOrderId=${superOrderId}&action=${action}&value=${value}&dealerId=${Vue.prototype.$session.get('dealerId')}`)
      .then((res) => res)
      .catch((error) => {
        throw error;
      });
  },
};
